module.exports = __webpack_public_path__ + "static/new-pio-logo-c8134e4ef4b60449c11979ffbc6848f4.png";